















































































import BaseDialog from '@/components/BaseDialog.vue';

import { PropType } from 'vue';
import { TAutoclickerScriptRecord, ValidationRules } from '@/api/schema';
import * as vr from '@/helpers/validation';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import {
  createAutoclickerScript,
  updateAutoclickerScript
} from '@/api/CopyStake/AutoClicker';

const MAX_PROMPT_LENGTH = 200;
const defaultFormData = (): Partial<TAutoclickerScriptRecord> => {
  return {
    id: null,
    name: '',
    phrases: ['']
  };
};

export default {
  name: 'CopyStakeAutoclickerPromptsModal',
  components: {
    BaseDialog
  },
  props: {
    promptData: {
      type: Object as PropType<Partial<TAutoclickerScriptRecord>>,
      default: null
    },
    language: {
      type: String
    },
    value: {
      type: Boolean as PropType<boolean>,
      default: (): boolean => false
    }
  },
  data(): any {
    return {
      MAX_PROMPT_LENGTH,

      formData: { ...defaultFormData() },
      isFormValid: true,
      loading: {
        processing: false
      }
    };
  },
  computed: {
    isNewConfig(): boolean {
      return !this.promptData;
    },
    isCopyConfig(): boolean {
      return !this.promptData?.id && this.promptData?.name;
    },
    isEditConfig(): boolean {
      return this.promptData?.id && this.promptData?.name;
    },
    isLoading(): boolean {
      return Object.values(this.loading).some(Boolean);
    },

    getTitle(): string {
      if (this.isCopyConfig) return 'Add Scripts from Copy';
      if (this.isEditConfig) return 'Scripts Editing';

      return 'Add New Scripts';
    },
    getSubmitText(): string {
      if (this.isCopyConfig) return 'Save as New';
      if (this.isEditConfig) return 'Update Scripts';

      return 'Create Scripts';
    },

    rules(): ValidationRules {
      return {
        name: [(v: string) => vr.required(v, 'Scripts Set Name')],
        prompt: [
          (v: string) => vr.required(v, 'Phrase'),
          (v) => {
            return vr.maxLength(v, MAX_PROMPT_LENGTH);
          }
        ]
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetForm();

      if (!open) {
        return;
      }

      if (this.isEditConfig || this.isCopyConfig)
        this.formData = {
          ...this.promptData
        };
    }
  },
  methods: {
    async resetForm(): Promise<void> {
      await this.$refs.form?.reset();

      this.formData = { ...defaultFormData() };
    },

    handleAddPrompt(): void {
      this.formData.phrases.push('');

      this.$nextTick(() => {
        const wrap =
          (this.$refs.phrasesScroll as any)?.$el || this.$refs.phrasesScroll;
        if (wrap) wrap.scrollTop = wrap.scrollHeight;

        this.$nextTick(() => {
          requestAnimationFrame(() => {
            const refs = (this.$refs.phraseInput as any[]) || [];
            const last = Array.isArray(refs) ? refs[refs.length - 1] : refs;
            const el = last?.$el || last;
            if (typeof last?.focus === 'function') last.focus();
            else el?.querySelector?.('input, textarea')?.focus?.();
          });
        });
      });
    },
    handleRemovePrompt(index: number): void {
      if (this.formData.phrases.length === 1) return;

      this.formData.phrases.splice(index, 1);
    },

    async handleSubmit(): Promise<void> {
      await this.$refs.form.validate();

      if (!this.isFormValid || this.isLoading || !this.language) return;

      this.loading.processing = true;

      const cleanedPhrases = (this.formData.phrases || [])
        .map((p: string) => (p ?? '').toString().trim())
        .filter((p: string) => p.length > 0)
        .map((p: string) => p.slice(0, MAX_PROMPT_LENGTH));
      const payload = {
        name: this.formData.name,
        language: this.language,
        phrases: cleanedPhrases
      };

      if (this.isNewConfig || this.isCopyConfig) {
        createAutoclickerScript(payload)
          .then((data) => {
            this.$toast.success('AI Streamer Scripts created');
            this.$emit('update', data.id);
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      } else {
        updateAutoclickerScript(this.promptData.id, payload)
          .then((data) => {
            this.$toast.success('AI Streamer Scripts updated');
            this.$emit('update', data.id);
            this.closeModal();
          })
          .catch(errorToastMessage)
          .finally(() => {
            this.loading.processing = false;
          });
      }
    },

    closeModal(): void {
      this.$emit('input', false);
    }
  }
};
